/*
 * File: CompletionStep.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 26, 2022 at 6:25 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: May 13, 2024 at 11:18 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Constants
import { mobileBreakpoint } from '../../../../styles/constants';


/**
 * Styles
 */

export const StepContainer = styled.div`
	width: 100%;
	max-width: 750px;
	margin: 0px auto;

	@media only screen {
		padding-top: 20px;
		padding-bottom: 30px;
	}
	@media only screen and (min-width: ${mobileBreakpoint}em) {
		padding-top: 20px;
		padding-bottom: 30px;
	}
	.cardPadding {
		padding: 100px 50px;
		background-image: url('${process.env.CDN_URL}/public/assets/decorations/white-gold-stars-decoration.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
	h3 {
		text-align: center;
		margin: 10px 0px 20px;
	}
	p {
		text-align: center;
		color: ${({ theme }) => theme.secondaryText};
		max-width: 480px;
		width: 100%;
		margin: 0px auto;
	}
	& > div > button {
		margin-top: 30px;
	}
	button {
		width: 200px;
		margin: 0px auto;
	}
`;

export const IconContainer = styled.div`
	text-align: center;
	color: ${({ theme }) => theme.brandTertiaryBase};
	margin-bottom: 15px;
	position: relative;
	display: inline-flex;

	svg {
		font-size: 3.4rem;
	}
`;

export const ConfettiTarget = styled.div`
	position: absolute;
	top: 25px;
	left: 25px;
`;
